import template from '../templates/LeaveLayout.html';

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.MainView = options.MainView;
        this.render();
    },

    render: function() {
        this.$el.html(template());
        return this;
    },

    renderContent: function(options) {
        new this.MainView(
            Object.assign({el: this.$('.js-content')}, options || {})
        );
    },

    hideLoader: function() {
        this.$('.js-loader').hide();
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/LeaveLayout.js